import { apm } from "@elastic/apm-rum";
import { Error, ErrorOutline } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { sidebarStore } from "shared/common/stores/sidebarStore";

export default function FeatureInfo() {
  const { t } = useTranslation();

  const infosPopover = sidebarStore((state) => state.infosPopover);
  const changeInfosPopover = sidebarStore((state) => state.changeInfosPopover);
  const measurementPopover = sidebarStore((state) => state.measurementPopover);

  //open or close infos popover
  const handleClickInfos = () => {
    changeInfosPopover(!infosPopover);
  };

  useEffect(() => {
    // close feature picker when measurement is opened
    if (measurementPopover) {
      changeInfosPopover(false);
    }
  }, [measurementPopover]);

  return (
    <Tooltip
      title={t("tooltip.info")}
      placement="right"
      enterDelay={400}
      classes={{
        tooltip: "infra3d-buttonDescription",
      }}
    >
      <IconButton
        className="onboarding-featureInfo"
        sx={{
          width: "40px",
          mx: "auto",
          color: "white",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
        classes={{
          root: infosPopover
            ? "infra3d-iconButtonRippleActive"
            : "infra3d-iconButtonRipple",
        }}
        onClick={() =>
          monitor(apm, "change-status-featureInfo | Toolbar", handleClickInfos)
        }
        disableRipple={true}
      >
        {!infosPopover && (
          <ErrorOutline
            sx={{
              rotate: "180deg",
            }}
          />
        )}
        {infosPopover && (
          <Error
            sx={{
              rotate: "180deg",
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}
